import { render } from "./AddProcessModal.vue?vue&type=template&id=6267156d&scoped=true&ts=true"
import script from "./AddProcessModal.vue?vue&type=script&lang=ts"
export * from "./AddProcessModal.vue?vue&type=script&lang=ts"

import "./AddProcessModal.vue?vue&type=style&index=0&id=6267156d&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6267156d"]])

export default __exports__